<template>
  <div>
    <div class="row">
      <span class="color-order-basket-title mb-3">{{ trans('sample_order_in_your_basket') }}:</span>
      <color-sample-overview :canModifyQuantity="false" :canModifyStructure="false" :items="items" :currency="currency"/>
    </div>
    <div class="row">
      <div class="col col-12 col-md-6">
        <div class="color-sample-details-title mb-4">
          {{ trans('sample_order_billing_details') }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_name') }}: {{ customerData.billing_name }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_company_name') }}: {{ customerData.billing_company_name }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_address') }}: {{ customerData.billing_zip }} {{ customerData.billing_city }}, {{ customerData.billing_address }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_vat_number') }}: {{ customerData.billing_vat_number }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_email') }}: {{ customerData.billing_email }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_phone') }}: {{ customerData.billing_phone }}
        </div>
      </div>
      <div class="col col-12 col-md-6">
        <div class="color-sample-details-title mb-4">
          {{ trans('sample_order_delivery_details') }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_name') }}: {{ customerData.name }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_company_name') }}: {{ customerData.company_name }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_address') }}: {{ customerData.zip }} {{ customerData.city }}, {{ customerData.address }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_email') }}: {{ customerData.email }}
        </div>
        <div class="color-sample-detail">
          {{ trans('sample_order_phone') }}: {{ customerData.phone }}
        </div>
      </div>
    </div>
    <div class="row  mt-5">
      <div class="color-order-back" @click="goBack" v-if="false">
        {{ trans('sample_order_back_to_delivery_and_billing_details') }}
      </div>
      <div v-else class="col-12 col-md-6">
        <button type="button" class="button type-15 sample-order-checkout-back-button" @click="goBack">
          <i class="material-icons">keyboard_backspace</i>
          {{ trans('calc_navigation_back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ColorSampleOverview from './ColorSampleOverview';
import {translate} from "../service/translation";
export default {
  components : {
    ColorSampleOverview
  },
  props : {
    customerData : {
      required : true,
      type : Object
    },
    items : {
      required : true,
      type : Array
    },
    currency : {
      required : true,
      type : String
    }
  },
  data() {
    return {
    }
  },
  methods : {
    goBack() {
      this.$emit('back');
    },
    trans(key){
      return translate(key);
    },
  },
}
</script>
<style>
.color-sample-details-title {
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  color: #000000;
}
.color-sample-detail {
  font-family: FranklinGothicBookITC;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  color: #000000;
  padding-bottom:0px;
}
.color-order-billing-title {
  display: block;
  width:100%;
  margin-top:20px;
  margin-bottom:10px;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
}
.color-order-billing-subtitle {
  display: block;
  width:100%;
  font-family: FranklinGothicBookITC;
  font-style: normal;
  font-weight: normal;
  font-size: 19px;
}
.color-order-back {
  width:100%;
  max-width:456px;
  display:block;
  background:#E4E4E4;
  color:#757575;
  text-align: center;
  margin-top:90px;
  margin-bottom:30px;
  padding:15px !Important;
  text-decoration: none;
  text-transform: uppercase;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  cursor:pointer;
}
.color-order-basket-title {
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
}

.color-order-billing-radio-container {
  position:relative;
  cursor: pointer;
}
.color-order-billing-radio {
  position:absolute;
  top:8px;
  cursor: pointer;
}
.sample-order-checkout-back-button.button.type-1{
  background:#E4E4E4;
}
.sample-order-checkout-back-button.button.type-1:hover{
 background:#d4d4d4;
}
</style>